import { ApiHelperService, ApiService } from '../../../../shared/services/api';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { SetupFiscalYearRequest } from '../models';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SetupService {

  endpointUrl: string;

  constructor(private api: ApiService,
    { reportsServiceUrl }: ApiHelperService) {
    this.endpointUrl = `${reportsServiceUrl}/api/year`;
  }

  public getAnticipatedExpenditures(propertyId: string, fiscalYear: number) {
    return this.api.get(`${this.endpointUrl}/anticipatedexpenditures/${propertyId}/${fiscalYear}`)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error))
      );
  }

  public setupFiscalYear(setupRequest: SetupFiscalYearRequest) {
    return this.api.post(`${this.endpointUrl}/setup/${setupRequest.propertyId}/${setupRequest.fiscalYear}`, setupRequest)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error))
      );
  }

  public skipFiscalYearSetup(propertyId: string, fiscalYear: number) {
    return this.api.get(`${this.endpointUrl}/skipsetup/${propertyId}/${fiscalYear}`)
      .pipe(
        map(response => response.data),
        catchError((error) => this.handleError(error))
      );
  }

  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
